import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import {
    useTheme,
    Box,
    alpha,
    Typography,
    Button,
    CircularProgress,
    Modal,
    //
} from '@mui/material';
import { LowPriority } from '@material-ui/icons';
import { fetchUser } from '../../../../../main/apps/FunctionalApps/user-management/UserManagement.queries';
import { fetchOptions } from '../../queries';
import { PriorityModal } from '.';

const PriorityList = ({ props }) => {
    const { name, label } = props;
    const { clearErrors, setError, setValue } = useFormContext();
    const theme = useTheme();
    const { id } = useParams();
    const [options, setOptions] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [priorityNumber, setPriorityNumber] = useState(0);
    const [priorityList, setPriorityList] = useState([]);
    const [loading, setLoading] = useState(false);

    const updatePriorityList = (list) => {
        const listIds = list.map((item) => item._id);
        setValue(name, listIds);
        setOptions(list);
        setPriorityNumber(list.findIndex((opt) => opt._id === id) + 1);
    };

    useEffect(() => {
        const getOptions = async () => {
            setLoading(true);
            try {
                const processorResponse = await fetchUser(id);
                if (!processorResponse || processorResponse.length === 0) {
                    setError(name, { type: 'fetch options', message: 'Could not fetch processor data.' });
                    return;
                }

                const processor = processorResponse[0];

                const optionsResponse = await fetchOptions({
                    endpoint: '/global-configuration/processorPriorities',
                });

                if (optionsResponse.error) {
                    setOptions([]);
                    setError(name, { type: 'fetch options', message: 'Could not fetch priority options' });
                } else {
                    // Check if processor is already in the priority list
                    const config = optionsResponse[0] || {};
                    const optionsList = config[name] || [];

                    const processorInOptions = optionsList.some((option) => option._id === processor._id);

                    // If processor is not in priority list, add it to the end
                    const updatedOptions = processorInOptions ? [...optionsList] : [...optionsList, processor];
                    updatePriorityList(updatedOptions);
                    clearErrors([name]);
                }
            } catch (error) {
                setError(name, { type: 'fetch', message: error.message || 'An error occurred while fetching data' });
                setOptions([]);
            } finally {
                setLoading(false);
            }
        };

        getOptions();
    }, []);

    useEffect(() => {
        if (openModal) {
            updatePriorityList(priorityList);
            setOpenModal(false);
        }
    }, [priorityList]);

    if (loading) {
        return <CircularProgress />;
    }

    return (
        <>
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <>
                    <PriorityModal
                        label={label}
                        options={options}
                        setOpenModal={setOpenModal}
                        setPriorityList={setPriorityList}
                        //
                    />
                </>
            </Modal>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                paddingY={1}
                paddingX={2}
                borderRadius={2}
                sx={{
                    backgroundColor: alpha(theme.palette.info.main, 0.2),
                    svg: {
                        fill: theme.palette.info.main,
                    },
                }}
            >
                <Box display="flex">
                    <LowPriority />
                    <Typography variant="body1" paddingLeft={1}>
                        Priority: {priorityNumber}/{options.length ?? 0}
                    </Typography>
                </Box>
                <Button onClick={() => setOpenModal(true)} color="secondary">
                    Edit
                </Button>
            </Box>
        </>
    );
};

export default PriorityList;
